/**
 * Verification status
 *
 */
export enum VerificationStatus {
    None,
    Loading,
    Verified,
    UnknownError,
    IsFull,
    UnableToConnect,
    Cancelled,
    ShowAndReturn,
}

export class ItineraryVerifyException {
    /**
     * Error type of the exception
     *
     * @type {VerificationStatus}
     * @memberof ItineraryVerifyException
     */
    error: VerificationStatus;

    /**
     * The customed massage for the exception
     *
     * @type {string | null}
     * @memberof ItineraryVerifyException
     */
    customMessage: string | null;

    /**
     * Creates an instance of TripVerifyException
     *
     * @memberof ItineraryVerifyException
     */
    constructor(
        error: VerificationStatus,
        customMessage: string | null = null,
        public cause?: unknown
    ) {
        this.error = error;
        this.customMessage = customMessage;
    }
}

export class ServerDisconnectToDateException extends MrError {
    override name = 'ServerDisconnectToDateException';
    constructor(
        public disconnectToDate: Date,
        message: string
    ) {
        super(message, true);
    }
}

export class TrainNoServerResponseError extends MrError {
    override message =
        'متأسفیم! به دلیل عدم دریافت اطلاعات از سرورهای مبدأ (راه آهن)، پاسخی برای درخواست شما یافت نشد.';

    override ignorable = true;
}

export class PrepayReserveError extends Error {
    constructor(
        message?: string,
        public expired?: boolean,
        public newPrice?: number,
        public oldPrice?: number
    ) {
        super(message);
    }
}

export class RegisterPaxError extends Error {
    constructor(
        message: string,
        public result: boolean,
        public departureTime: Date | null,
        public data?: any
    ) {
        super(message);
    }
}
